import { Component, OnInit,ViewChild } from '@angular/core';
import { APIComplaintsService } from '../../_services/complaints/API-complaints';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { MatPaginator, MatTableDataSource,MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-complaints-ncpr-summary',
  templateUrl: './complaints-ncpr-summary.component.html',
  styleUrls: ['./complaints-ncpr-summary.component.css']
})
export class ComplaintsNcprSummaryComponent implements OnInit {
  dataSubject = new BehaviorSubject<any[]>([]);
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['BatchId', 'Upload_Date', 'NCPR_File_Name', 'Input_Count', //'Status', 
  'Success_Count', 'Failure_Count'];
 /*  'Uploaded By', */
 form1: any = {};
 fetchedData:any;

 onChangeDataSource(value)
{
  this.dataSubject.next(value);
  this.dataSource = new MatTableDataSource();
  
  this.dataSource = new MatTableDataSource(value);
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort=this.sort;
 // console.log("dataSource : ", this.dataSource);
  
      
}
dataSource: any;
  public reqId: any;
  public ncprFilename: any;
  public reqDate: any;
  public uploadedBy: any;
  public userName: any;
  public succssTotalCount:any = {};
  public failureTotalCount:any = {};
  public mmscmtotal:any = {};
  form: any = {};
  complaintsSummary: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private imp: APIComplaintsService,
   // private db: $DBManagerService,
   // private fb:FormBuilder
  ) { }
  
  ngOnInit() {
    this.getcomplaintsNCPRSummary();
  }

  getcomplaintsNCPRSummary(){
   // console.log("coming inside");
    this.imp.getImportComplaintsSummary()
    .subscribe(m => {
      this.complaintsSummary = m;
     console.log("complaintsummary :::: ", JSON.stringify(this.complaintsSummary));
     // console.log("complaintsummary :::: ", m);
	   
      this.complaintsSummary.map((val, i) => {
         this.dataSource = m;
         this.onChangeDataSource(m);
		})

    });
  }


    calculateTotalSuccessValue(index,datas){
	
      let value=0;
      datas.map((val)=>{
		 
        value= value+ val.SuccessCount;
      })
	 
     this.succssTotalCount[index]= value;
  } 
  
      calculateTotalFailureValue(index,datas){
	
      let value=0;
      datas.map((val)=>{
		 
        value= value+ val.FailedCount;
      })
	 
     this.failureTotalCount[index]= value;
  } 

}
export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}